import { Component } from 'react';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div data-testid="error-boundary-fallback" style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'var(--cream, #F5F0EB)',
          fontFamily: 'Jost, sans-serif',
        }}>
          <div style={{ textAlign: 'center', maxWidth: 420, padding: 32 }}>
            <div style={{ fontSize: 48, marginBottom: 16, color: 'var(--bark, #1C1814)' }}>
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
            </div>
            <h1 style={{ fontSize: 22, color: 'var(--bark, #1C1814)', margin: '0 0 8px', fontWeight: 500 }}>Something went wrong</h1>
            <p style={{ fontSize: 14, color: '#8B7E74', margin: '0 0 24px', lineHeight: 1.6 }}>
              An unexpected error occurred. Please try refreshing the page.
            </p>
            <button
              data-testid="error-boundary-reload"
              onClick={() => window.location.reload()}
              style={{
                padding: '12px 32px',
                background: 'var(--bark, #1C1814)',
                color: '#fff',
                border: 'none',
                borderRadius: 6,
                fontSize: 13,
                fontFamily: 'Jost, sans-serif',
                letterSpacing: 1,
                textTransform: 'uppercase',
                cursor: 'pointer',
              }}
            >
              Refresh Page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
